export default "__VITE_ASSET__DFbSnHWv__"